import { DEFAULT_TENANT_ID } from '../../../contexts/tenantSelection';
import type { AssignmentSourceFilter } from './sourceFilter';

/** Gilt für jeden Umzug: Tokens des bisherigen Tenants laufen erst mit ihrer TTL ab. */
const TOKEN_NOTICE = 'Bereits ausgestellte Tokens des bisherigen Tenants bleiben bis zu ihrem Ablauf (max. 60 Min.) gültig.';

/** Umzug in einen Partner-Tenant (CA-755): Kunde verliert den Portal-Zugang, Bots werden extern gepflegt. */
const INTO_PARTNER_IMPACTS: readonly string[] = [
  'Alle Nutzer dieser Kunden verlieren den Portal-Login. Laufende Sitzungen enden beim nächsten Aufruf.',
  'Alle Bots werden auf „eigenen Prompt“ umgestellt: Der Prompt wird extern über die API gepflegt und ist im Portal nur noch lesbar.',
  'Der Partner verwaltet die Bots dieser Kunden ab sofort über die External API.',
  'Admin-Impersonation bleibt möglich, aber nur lesend.',
];

/** Rückweg aus einem Partner- in den Default-Tenant: Portal-Zugang und Baustein-Pflege kommen zurück. */
const OUT_OF_PARTNER_IMPACTS: readonly string[] = [
  'Die Kunden erhalten wieder Portal-Login und pflegen ihre Bots selbst.',
  'Bots mit Bausteinen werden wieder aus Bausteinen gepflegt. Ein zwischenzeitlich per API gesetzter Prompt wird beim nächsten Speichern im Portal aus den Bausteinen neu erzeugt.',
  'Bots ohne Bausteine bleiben auf eigenem Prompt.',
  'Der bisherige Partner verliert den Zugriff über die External API.',
];

/**
 * Auswirkungen eines Tenant-Umzugs für die Warnbox im Zuweisen-Dialog (CA-755).
 * Spiegelt `AdminTenantsService.reassignCustomers` — bei Änderungen dort mitziehen.
 * @param source Quell-Filter (Herkunft der ausgewählten Kunden).
 * @param targetTenantId Ziel-Tenant; null = noch nicht gewählt.
 * @returns Auswirkungen in Anzeige-Reihenfolge; der Token-Hinweis steht immer am Ende.
 */
export function reassignImpacts(source: AssignmentSourceFilter, targetTenantId: string | null): string[] {
  if (targetTenantId === null) return [TOKEN_NOTICE];
  if (targetTenantId !== DEFAULT_TENANT_ID) return [...INTO_PARTNER_IMPACTS, TOKEN_NOTICE];
  const fromPartner = source.kind === 'tenant' && source.tenant.id !== DEFAULT_TENANT_ID;
  return fromPartner ? [...OUT_OF_PARTNER_IMPACTS, TOKEN_NOTICE] : [TOKEN_NOTICE];
}
